

const StatelessComponent = (props) => {
    return (
        <p>Ini adalah komponen Stateless Component {props.text}</p>
    )
}

export default StatelessComponent